module.exports = __webpack_public_path__ + "static/media/white-background.d4da5435.svg";